import type { IconData } from '@stacksjs/iconify-core'

export const codingAppsWebsitesDatabase: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.19 27.43h1.53v-1.52h1.52V6.1h-1.52v1.52h-1.53v1.52h-4.57v1.53H8.38v1.52H22.1v7.62h1.52v-1.52h4.57v-1.53h1.53v1.53h-1.53v1.52h-4.57v1.52H22.1v7.62H8.38v1.53h15.24v-1.53h4.57zM26.67 4.57h3.05V6.1h-3.05ZM22.1 3.05h4.57v1.52H22.1Z\"/><path fill=\"currentColor\" d=\"M8.38 19.81H22.1v1.52H8.38Zm1.53 4.57h4.57v1.53H9.91Zm0-9.14h4.57v1.52H9.91Zm0-13.72H22.1v1.53H9.91Zm-6.1 25.91h4.57v1.52H3.81Zm0-9.14h4.57v1.52H3.81Zm0-9.15h4.57v1.53H3.81Zm1.52-6.09h4.58v1.52H5.33ZM3.81 21.33h3.05v3.05H3.81Zm0-9.14h3.05v3.05H3.81ZM2.29 4.57h3.04V6.1H2.29Zm0 21.34h1.52v1.52H2.29Zm0-7.62h1.52v-1.53H2.29V9.14h1.52V7.62H2.29V6.1H.76v19.81h1.53z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default codingAppsWebsitesDatabase
